import * as React from 'react';
import { PortsGroupDefault } from '../../';
export const PortsDefault = ({ children, config }) => {
    return (React.createElement("div", null,
        React.createElement(PortsGroupDefault, { config: config, side: "top" }, children.filter((child) => ['input', 'top'].includes(child.props.port.type))),
        React.createElement(PortsGroupDefault, { config: config, side: "bottom" }, children.filter((child) => ['output', 'bottom'].includes(child.props.port.type))),
        React.createElement(PortsGroupDefault, { config: config, side: "right" }, children.filter((child) => ['right'].includes(child.props.port.type))),
        React.createElement(PortsGroupDefault, { config: config, side: "left" }, children.filter((child) => ['left'].includes(child.props.port.type)))));
};
